 
import React, { useState, useEffect } from "react";
import {
  Table,
  Tooltip,
  OverlayTrigger,
  Modal,
  Button,
  Form,
} from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import SVG from "react-inlinesvg";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  LoadingDialog,
} from "../../../_metronic/_partials/controls";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { getDemoMode } from "../../../helpers";
import {
  getNewsletters,
  getSearchNewsletters,
  deleteNewsletter,
} from "../../../store/actions";
import moment from "moment";
import SearchNewsletter from "./SearchNewsletter";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { authCheckState } from "../../../store/actions/index";
import SortDropdownHeader, {
  sortData,
} from "../../components/common/SortDropdownHeader/SortDropdownHeader";
function Newsletter() {
  const demoMode = getDemoMode();
  const methods = useForm({ mode: "onTouched" });
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [transactionInfo, setTransactionInfo] = useState();
  const [showMore, setShowMore] = useState(2);
  const [TransactionFilterData, setTransactionFilterData] = useState();
  const campaignSWAL = withReactContent(Swal);

  const [sortConfig, setSortConfig] = useState({
    column: null,
    direction: null,
  });
  useEffect(() => {
    dispatch(authCheckState());
    dispatch(getNewsletters(1));
  }, [dispatch]);

  const { newsletters, loading } = useSelector((state) => state.newsletter);
  const { generalSettings } = useSelector((state) => state.settings);
  const { currentPermissions } = useSelector((state) => state.role);
  const loadMore = () => {
    setShowMore(showMore + 1);
    if (
      TransactionFilterData !== undefined &&
      Object.keys(TransactionFilterData).length > 0
    ) {
      dispatch(getSearchNewsletters(TransactionFilterData, showMore));
    } else {
      dispatch(getNewsletters(showMore));
    }
  };

  const campaignActions = (id, title, text, variant) => {
    campaignSWAL
      .fire({
        title: title,
        text: text,
        icon: variant,
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        allowEscapeKey: false,
        reverseButtons: true,
      })
      .then((result) => {
        if (result["isConfirmed"]) {
          dispatch(deleteNewsletter(id));
        }
      });
  };

  const showTransactionDetail = (data) => {
    setShow(true);
    setTransactionInfo(data);
  };

  const handleClose = () => {
    setShow(false);
    setTransactionInfo();
  };

  const onSubmit = (data) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTransactionFilterData(data);
    setShowMore(2);
    dispatch(getSearchNewsletters(data, 1));
  };

  const sortOptions = {
    name: (row) => `${row?.firstName || ""} ${row?.lastName || ""}`.trim(),
    email: (row) => row?.email || "",
    createdAt: (row) => row?.createdAt || "",
    subscriptionType: (row) => row?.subscriptionType || "",
  };

  const handleSort = (column, direction) => {
    setSortConfig({ column, direction });
  };

  const sortedNewsletters = newsletters?.docs
    ? sortData(newsletters.docs, sortConfig, sortOptions)
    : [];
  const transactionList =
    sortedNewsletters?.length > 0 ? (
      sortedNewsletters?.map((transaction, key) => (
        <tr key={key}>
          {/* <td>
            {transaction?.firstName} {transaction?.lastName}
          </td> */}
          <td>{transaction?.email}</td>
          <td>
            {moment(transaction.createdAt).format(generalSettings.dateFormat) ??
              "-"}
          </td>
          <td>{transaction?.subscriptionType}</td>
          {demoMode === "false" ? (
            <td className="d-flex gap-2">
              {currentPermissions?.view_newsletters && (
                <OverlayTrigger
                  popperConfig={{
                    modifiers: {
                      preventOverflow: {
                        enabled: false,
                      },
                      hide: {
                        enabled: false,
                      },
                    },
                  }}
                  placement="bottom"
                  overlay={<Tooltip>View</Tooltip>}>
                  <button
                    onClick={() => showTransactionDetail(transaction)}
                    id={`kt_view_transaction_toggle_${key}`}
                    className="action-btn-secondary me-3">
                    <span className="btn-svg">
                      <SVG
                        title=" "
                        src={toAbsoluteUrl(
                          "media/svg/icons/General/Visible.svg"
                        )}
                      />
                    </span>
                  </button>
                </OverlayTrigger>
              )}
              {currentPermissions?.delete_newsletters && (
                <OverlayTrigger
                  popperConfig={{
                    modifiers: {
                      preventOverflow: {
                        enabled: false,
                      },
                      hide: {
                        enabled: false,
                      },
                    },
                  }}
                  placement="bottom"
                  overlay={<Tooltip>Delete</Tooltip>}>
                  <button
                    onClick={() =>
                      campaignActions(
                        transaction?._id,
                        "Confirm ?",
                        "Are you sure you want to delete this Subscriber ?",
                        "error"
                      )
                    }
                    id={`kt_view_transaction_toggle_${key}`}
                    className="action-btn-danger">
                    <span className="btn-svg">
                      <SVG
                        title=" "
                        src={toAbsoluteUrl("media/svg/icons/General/Trash.svg")}
                      />
                    </span>
                  </button>
                </OverlayTrigger>
              )}
            </td>
          ) : null}
        </tr>
      ))
    ) : (
      <tr className="text-center">
        <td className="text-primary fw-medium" colSpan={7}>
          {newsletters?.docs?.length === 0 ? (
            <span>
              <img
                height={120}
                src={toAbsoluteUrl("media/animations/nodata-animation.gif")}
                alt="no data found!"
              />
              <br />
              <span className="text-primary fs-6 fw-bold">
                No Data Available!
              </span>
            </span>
          ) : (
            "Loading..."
          )}
        </td>
      </tr>
    );
  if (transactionList?.docs?.length < 1) {
    return (
      <>
        <LoadingDialog />
      </>
    );
  } else {
    return (
      <>
        <FormProvider {...methods}>
          <Form
            name="searchNewsletter"
            onSubmit={methods.handleSubmit(onSubmit)}>
            <SearchNewsletter></SearchNewsletter>
          </Form>
        </FormProvider>
        <Card className="mt-4">
          <CardHeader title="Newsletters"></CardHeader>
          <CardBody className="pt-0 px-6 pb-6">
            <div className="sticky-table-header-wrapper">
              <Table className="table-head-custom table-custom-bg table-vertical-center">
                <thead>
                  <tr>
                    {/* <th>
                    <SortDropdownHeader
                      columnKey="name"
                      onSort={handleSort}
                      currentSort={sortConfig}>
                      Name
                    </SortDropdownHeader>
                  </th> */}
                    <th>
                      <SortDropdownHeader
                        columnKey="email"
                        onSort={handleSort}
                        currentSort={sortConfig}>
                        Email
                      </SortDropdownHeader>
                    </th>
                    <th>
                      <SortDropdownHeader
                        columnKey="createdAt"
                        onSort={handleSort}
                        currentSort={sortConfig}>
                        Date
                      </SortDropdownHeader>
                    </th>
                    <th>
                      <SortDropdownHeader
                        columnKey="subscriptionType"
                        onSort={handleSort}
                        currentSort={sortConfig}>
                        Subscription Type
                      </SortDropdownHeader>
                    </th>
                    {demoMode === "false" ? (
                      <th className="width110">Action</th>
                    ) : null}
                  </tr>
                </thead>
                <tbody>{transactionList}</tbody>
              </Table>
              {newsletters?.displayLoadMore ? (
                <div className="mt-5 text-center">
                  <Button
                    type="button"
                    className="btn btn-dark py-2 mb-5"
                    onClick={() => loadMore()}>
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"></span>
                    ) : (
                      "Load More"
                    )}
                  </Button>
                </div>
              ) : null}
            </div>
          </CardBody>
        </Card>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title>
              Subscriber Detail: {transactionInfo?.firstName}{" "}
              {transactionInfo?.lastName}
            </Modal.Title>
            <button
              type="button"
              className="btn btn-dark py-1 font-size-sm ms-auto"
              onClick={handleClose}>
              Close
            </button>
          </Modal.Header>
          <Modal.Body className="py-6 px-4 pt-0">
            <div>
              <ul className="p-0 m-0">
                <li className="d-flex justify-content-between bg-table-bg-clr rounded-fix p-3 text-black mb-3">
                  <span>Newsletter ID</span>
                  <strong className="ms-4">
                    {transactionInfo?.listId ?? "-"}
                  </strong>
                </li>
                <li className="d-flex justify-content-between bg-table-bg-clr rounded-fix p-3 text-black mb-3">
                  <span>Email</span>
                  <strong className="ms-4">{transactionInfo?.email}</strong>
                </li>
                <li className="d-flex justify-content-between bg-table-bg-clr rounded-fix p-3 text-black mb-3">
                  <span>Subscription Type</span>
                  <strong className="ms-4">
                    {transactionInfo?.subscriptionType ?? "-"}
                  </strong>
                </li>
                <li className="d-flex justify-content-between bg-table-bg-clr rounded-fix p-3 text-black">
                  <span>Date</span>
                  <strong className="ms-4">
                    {moment(transactionInfo?.createdAt).format(
                      generalSettings?.dateFormat
                    ) ?? "-"}
                  </strong>
                </li>
              </ul>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default Newsletter;
